export default {
    GetMasters: 'api/public/masters',
    AddMaster: 'api/public/masters',
    DeleteMaster: 'api/public/masters',
    UpdateMaster: 'api/public/masters',
    GetMasterById: 'api/public/masters',
  };
  